import React from "react";
import { UI_CAPTION } from "oolib";
import {
  StyledTooltipBox,
  StyledTooltipContent,
} from "@/components/dataviz/MetricsCard/styled";
import { getHiddenItemDisplay } from "@/components/analysisModules/reports/ReportLanding/comps/WidgetComps/WidgetBarChart/utils/hiddenDatapoints";

interface Filter {
  label: string;
  values: any[];
}

/**
 * Creates tooltip content configuration for filters
 */
export const createFilterTooltipContent = (filters: Filter[]) => ({
  layout: "custom" as const,
  render: (
    <StyledTooltipBox>
      {filters?.map((filter, index) => (
        <StyledTooltipContent key={index} $isLast={index === filters.length - 1}>
          <UI_CAPTION>{filter.label}</UI_CAPTION>
          {filter.values.map((value, vIndex) => (
            <UI_CAPTION key={vIndex}>{String(value)}</UI_CAPTION>
          ))}
        </StyledTooltipContent>
      ))}
    </StyledTooltipBox>
  ),
});

type HiddenDatapoint = string | { display: string; value: string };

/**
 * Creates tooltip content configuration for hidden datapoints
 */
export const createHiddenTooltipContent = (
  hiddenDim1Datapoints?: HiddenDatapoint[],
  hiddenDim2Datapoints?: HiddenDatapoint[]
) => {
  const hiddenDim1Count = hiddenDim1Datapoints?.length || 0;
  const hiddenDim2Count = hiddenDim2Datapoints?.length || 0;

  return {
    layout: "custom" as const,
    render: (
      <StyledTooltipBox>
        {hiddenDim1Count > 0 && (
          <StyledTooltipContent $isLast={hiddenDim2Count === 0}>
            {hiddenDim1Datapoints?.map((item, index) => (
              <UI_CAPTION key={index}>{getHiddenItemDisplay(item)}</UI_CAPTION>
            ))}
          </StyledTooltipContent>
        )}
        {hiddenDim2Count > 0 && (
          <StyledTooltipContent $isLast>
            {hiddenDim2Datapoints?.map((item, index) => (
              <UI_CAPTION key={index}>{getHiddenItemDisplay(item)}</UI_CAPTION>
            ))}
          </StyledTooltipContent>
        )}
      </StyledTooltipBox>
    ),
  };
};

/**
 * Creates tooltip content configuration for breakdown
 */
export const createBreakdownTooltipContent = (breakdownCategoryName: string) => ({
  layout: "custom" as const,
  render: (
    <StyledTooltipBox>
      <StyledTooltipContent $isLast>
        <UI_CAPTION>{breakdownCategoryName}</UI_CAPTION>
      </StyledTooltipContent>
    </StyledTooltipBox>
  ),
});
